import { Ref, forwardRef } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface Props {
  height: number
  width: number
  zoomValue: string
  ref: Ref<SVGSVGElement>
}

const Frame = forwardRef<SVGSVGElement, React.PropsWithChildren<Props>>(function Frame(
  { children, height, width, zoomValue },
  ref
) {
  return (
    <Box className={'Frame_frame'}>
      <div id="orgchart-div" style={{ width: width, height: height }}>
        <svg ref={ref} width={width} height={height}>
          <g transform={zoomValue}>{children}</g>
        </svg>
      </div>
    </Box>
  )
})

export default Frame
